<template>
  <div class="section lakasketia">
    <!--particle-->
    <div class="bg-particles">
      <vue-particles color="#ffff33" :particle-opacity="0.3" :hover-effect="false" :click-effect="false"
                     :line-linked="false"></vue-particles>
    </div>

    <!--以下ロード中は隠す-->
    <div :class="{'is-loading': !isLoadingEnd}">
      <!--トップ-->
      <div class="top">
        <div class="share-btns">
          <div id="fb-root"></div>
          <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-show-count="false">Tweet</a>
          <div class="fb-share-button" data-href="https://toykasket.net/release/tkcd0004/" data-layout="button" data-size="small" data-mobile-iframe="true">
            <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftoykasket.net%2Frelease%2Ftkcd0004%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">シェア</a>
          </div>
        </div>
        <div class="logo-parent">
          <div class="logo">
            <img src="../assets/Main/logo.png">
          </div>
        </div>
      </div>

      <!--ようこそ-->
      <Youkoso/>

      <FixArea/>
      <Store/>

    </div>
  </div>
</template>

<script>
  import FixArea from './Sections/FixArea';
  import Store from './Sections/Store';
  import Youkoso from './Sections/Youkoso';
  // アルバム情報を表示するメインのコンポーネント
  export default {
    name: 'Page',
    components: {
      FixArea, Store, Youkoso
    },
    props: {
      isLoadingEnd: true,
    },
  mounted: function() {
    const $ = require("jquery");
    const timerId = setInterval(() => {
      if (this.isLoadingEnd) {
        // facebook
        (function(d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          js.src =
            "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.1";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
        // twitter
        $.ajax({
          url: "https://platform.twitter.com/widgets.js",
          dataType: "script",
          async: true
        });

        clearInterval(timerId);
      }
    }, 100);
  }
  };
</script>

<style>
.fb_iframe_widget > span {
  vertical-align: baseline !important;
}
</style>

<style scoped lang="scss">
  .is-loading {
    display: none;
  }

.share-btns {
  position: absolute;
  display: inline;
  padding-top: 10px;
  padding-left: 10px;
  z-index: 200;
}

  .columns {
    padding: 0;
    margin: 0;
  }

  .lakasketia {
    max-width: 100vw;
    margin: 0;
    padding: 0;
  }

  .top {
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("../assets/Main/top.jpg");
  }

  .logo {
    position: absolute;
    margin-top: 50px;
    right: 5%;
    animation: horizontal 2.0s ease-in-out infinite alternate;
    @media screen and (max-width: 768px){
      right: 0;
    }
  }

  .logo-parent {
    position: relative;
    width: 100%;
    animation: vertical 3s ease-in-out infinite alternate;
  }

  @keyframes horizontal {
    0% {
      transform: translateX(-2px);
    }
    100% {
      transform: translateX(2px);
    }
  }

  @keyframes vertical {
    0% {
      transform: translateY(-5px);
    }
    100% {
      transform: translateY(5px);
    }
  }

  .bg-particles {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 1;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Page.vue